import BackButton from "../components/BackButton";
import ImageCompressor from "../components/ImageCompressor";
import { Helmet } from "react-helmet";

const ImageCompressorPage = () => {
  return (
    <>
     <Helmet>
        <title>Advanced Image Compressor - Free Online Tool</title>
        <meta
          name="description"
          content="Compress and resize images online with custom width, height, and quality. Free tool for JPG, PNG image optimization without losing quality."
        />
        <meta
          name="keywords"
          content="image compressor, jpg compressor, resize image online, image optimization tool, photo resizer, compress image quality"
        />
        <link rel="canonical" href="https://freelity.com/image-compressor" />
      </Helmet>
      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <ImageCompressor />
        </div>
      </section>
    </>
  );
};

export default ImageCompressorPage;
